module.exports = __webpack_public_path__ + "e5f99be65b1e70b8d6ab8057f6e378fb.png";